import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import Chart from "components/charts/Chart"

const ChartBlock = ({ title, rows }) => {
  return (
    <div
      css={theme.expandQueries({
        maxWidth: 943,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: [60, 45, 30],
        "& + &": {
          marginTop: [65, 55, 45],
        },
      })}
    >
      {title && (
        <h3
          css={{
            ...theme.t4,
            textAlign: "center",
            marginBottom: "1em",
          }}
        >
          {title}
        </h3>
      )}

      <div
        css={{
          display: "grid",
          gridTemplateColumns: "repeat(2, calc(50% - 16px))",
          gap: 32,
          [theme.mobile]: {
            gridTemplateColumns: "100%",
          },
          [theme.mobilePortrait]: {
            gap: 24,
          },
        }}
      >
        {rows.map((row, index) => (
          <Chart key={index} {...row} />
        ))}
      </div>
    </div>
  )
}

export default ChartBlock

ChartBlock.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.shape(Chart.propTypes).isRequired)
    .isRequired,
}
